import { useLanguage } from '@/contexts/LanguageContext';
import { motion } from 'framer-motion';
import tomAboutMain from '@/assets/tom-about-main.jpg';
import tomClientBudejovice from '@/assets/tom-client-budejovice.jpg';
import tomClientDeadpool from '@/assets/tom-client-deadpool.jpg';
import tomClientDeadpool2 from '@/assets/tom-client-deadpool-2.jpg';
import tomWithElias from '@/assets/tom-with-elias.jpg';
import tomClientBroz from '@/assets/tom-client-broz.jpg';
import tomSelfieMask from '@/assets/tom-selfie-mask.jpg';
import maskaCeskaLipa from '@/assets/airbrush_maska_ceska_lipa.jpg';
import maskaCeskeBudejovice from '@/assets/airbrush_maska_ceske_budejovice.jpg';
import maskaHSTTrebic from '@/assets/airbrush_maska_hst_trebic_new.jpg';
import maskaMartinUrbanek from '@/assets/airbrush_maska_martin_urbanek.jpg';
import maskaBratislava from '@/assets/airbrush_hokejove_masky_do_bratislavy.jpg';


const AboutSection = () => {
  const { t } = useLanguage();

  return (
    <section id="about" className="py-20 md:py-32 px-4">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <motion.div
            initial={{ opacity: 0, x: -40 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="relative flex flex-col"
          >
            <div className="relative">
              <img
                src={tomSelfieMask}
                alt={t.about.name}
                className="w-full object-contain rounded-sm"
              />
              <div className="absolute inset-0 border-2 border-primary/20 rounded-sm translate-x-4 translate-y-4 -z-10" />
            </div>
            <div className="flex-1 flex items-center justify-center mt-10 py-10">
              <p className="text-primary font-bold text-4xl md:text-7xl leading-tight italic text-center" style={{ fontFamily: 'Bebas Neue', letterSpacing: '0.1em' }}>
                „{t.hero.subtitle}"
              </p>
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 40 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <h2 className="text-5xl md:text-7xl tracking-wider text-foreground mb-2" style={{ fontFamily: 'Bebas Neue' }}>
              {t.about.title}
            </h2>
            <p className="text-primary text-xl mb-6" style={{ fontFamily: 'Bebas Neue', letterSpacing: '0.1em' }}>
              {t.about.name}
            </p>
            <p className="text-muted-foreground leading-relaxed mb-4">{t.about.bio}</p>
            <p className="text-muted-foreground leading-relaxed">{t.about.bio2}</p>
            <p className="text-muted-foreground leading-relaxed mt-4">{t.about.bio3}</p>
            <p className="text-primary font-semibold leading-relaxed mt-6">{t.about.bio4}</p>
          </motion.div>
        </div>

        {/* Photo grid - clients & work */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="mt-16 grid grid-cols-3 gap-3"
        >
          {[
            { src: tomClientBudejovice, alt: 'Tomáš Veselý předává custom airbrush brankářskou masku klientovi z Českých Budějovic' },
            { src: tomClientDeadpool, alt: 'Klient s hokejovou brankářskou maskou v airbrush designu Deadpool' },
            { src: tomWithElias, alt: 'Tomáš Veselý s brankářem Eliášem a jeho pomalovanou maskou' },
            { src: tomClientBroz, alt: 'Brankář Brož přebírá svoji novou airbrush masku od Tom Art Mask' },
            { src: maskaCeskaLipa, alt: 'Airbrush brankářská maska pro klub Česká Lípa' },
            { src: maskaCeskeBudejovice, alt: 'Airbrush brankářská maska v barvách Českých Budějovic' },
            { src: maskaHSTTrebic, alt: 'Airbrush brankářská maska pro HST Třebíč' },
            { src: maskaMartinUrbanek, alt: 'Custom airbrush maska brankáře Martina Urbánka' },
            { src: maskaBratislava, alt: 'Airbrush brankářská maska v designu Bratislava' },
          ].map((img, i) => (
            <div key={i} className="overflow-hidden rounded-sm aspect-square group">
              <img
                src={img.src}
                alt={img.alt}
                loading="lazy"
                className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110 mx-0"
              />

            </div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default AboutSection;
